
import React from 'react';
import { config } from "util/config";
import { message, Modal, Button, Image, Divider, Tooltip, Popconfirm } from 'antd';
import * as globalFunction from 'util/GlobalFunction';

export default class CustomImage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      hover: false
    }
  }

  render() {
    return (
      <div
        className={this.props.divClassName}
        onMouseEnter={() => {
          this.setState({ hover: true });
        }}
        onMouseLeave={() => {
          this.setState({ hover: false });
        }}
      >
        <Image
          className={this.props.imageClassName}
          src={this.props.src}
          fallback={config.component.Image.fallback}
        />
        {
          this.state.hover ? <div className='image-button-div'>{this.props.buttons}</div> : <></>
        }
      </div>
    )
  };
};
